import { Button, NoUserIcon } from "@jutro/ui";
import dayjs from "dayjs";
import { useAtom } from "jotai";
import { nanoid } from "nanoid";
import { useMemo } from "react";
import { useEdmGetAllVisitsForDeletedShiftsQuery } from "lib/graphql/megaSchema";
import { TileColumn } from "lib/tools/createWorkspace/types";
import { useTileSystem } from "lib/tools/createWorkspace/useTileSystem";
import { staffScheduleSelectedOrganizationIdAtom } from "views/StaffSchedule/atoms";

export const AllVisitsWithDeletedShiftsButton = () => {
  const { addTile } = useTileSystem();
  const [organizationId] = useAtom(staffScheduleSelectedOrganizationIdAtom);

  const { data, loading } = useEdmGetAllVisitsForDeletedShiftsQuery({
    variables: {
      organizationId,
    },
    fetchPolicy: "network-only",
  });

  const visitsWithoutStaff = useMemo(
    () =>
      data?.edmGetAllVisitsForDeletedShifts
        .filter((visit) => visit.state === "SCHEDULED")
        .filter(({ scheduledOn }) => dayjs(scheduledOn).isAfter(dayjs()))
        .sort((aShift, bShift) =>
          dayjs(aShift.scheduledOn).diff(dayjs(bShift.scheduledOn)),
        ) ?? [],
    [organizationId, data],
  );

  const handleAddTile = () => {
    const id = nanoid();
    addTile(
      {
        name: "visits-with-deleted-shift-table",
        id,
        data: { id, visits: visitsWithoutStaff, mode: "all" },
      },
      TileColumn.Left,
    );
  };

  return (
    <div>
      <Button
        text="Wizyty do przełożenia"
        variant="secondary"
        iconPosition="left"
        icon={<NoUserIcon />}
        onClick={handleAddTile}
        disabled={visitsWithoutStaff.length === 0 || loading}
        size="condensed"
      />
    </div>
  );
};
